import * as React from 'react';
export const IcRoutesTraffic = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.71 7.29l-2-2a1.004 1.004 0 00-1.42 1.42l.3.29H17a8 8 0 00-6 2.73V5.41l.29.3a.999.999 0 001.42 0 1.001 1.001 0 000-1.42l-2-2a.85.85 0 00-.3-.19A.85.85 0 0010 2h-.07a1 1 0 00-.24.05h-.1a1 1 0 00-.3.19l-2 2a1.022 1.022 0 101.42 1.47l.29-.3v8.94A3.448 3.448 0 007.5 14 1.5 1.5 0 016 12.5v-2.09l.29.3a1 1 0 001.42 0 1 1 0 000-1.42l-2-2a1 1 0 00-1.42 0l-2 2a1.004 1.004 0 001.42 1.42l.29-.3v2.09A3.5 3.5 0 007.5 16 1.5 1.5 0 019 17.5V21a1 1 0 002 0v-6a6 6 0 016-6h1.59l-.3.29a1 1 0 00.326 1.639 1 1 0 001.094-.219l2-2a1.001 1.001 0 000-1.42zM17 12a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91a.998.998 0 001.42 0C18 21.37 21 18.34 21 15.8a3.93 3.93 0 00-4-3.8zm0 5a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
